
import { Box, Button, Typography } from "@mui/material";
import { useEffect } from "react";
import { toast } from "react-toastify";
import { deletePackage, PaqueteDto } from "../../firebase/firestore/paquetes";
import { UserRole } from "../../interfaces/UserRole";
import { useAuthStore } from "../../zustand/useAuthStore";
import { usePaqueteStore } from "../../zustand/usePaquetesStore";
import Modal from "./Modal";

interface ModalDeletePackageProps {
    isOpen: boolean;
    onClose: () => void;
    paquete?: PaqueteDto;
    ids: string[];
}

interface ContentModalProps {
    ids: string[];
    idRastreo: string;
    onClose: () => void;
}

export default function ModalDeletePackage(props: ModalDeletePackageProps) {
    const { isOpen, onClose, paquete, ids } = props;
    
    // Determine which IDs to use: if ids array has items, use it; otherwise use paquete.id if available
    const idsToDelete = ids.length > 0 ? ids : (paquete ? [paquete.id] : []);
    
    // Determine idRastreo: if exactly one item and we have paquete info, show it
    const idRastreo = idsToDelete.length === 1 && paquete ? paquete.idRastreo : "";
    
    return (
        <Modal
            open={isOpen}
            onClose={onClose}
            title={"Eliminar paquete" + (idsToDelete.length > 1 ? "s" : "")}
            content={
                <ContentModal
                    ids={idsToDelete}
                    idRastreo={idRastreo}
                    onClose={onClose}
                />
            }
            sx={{
                marginX: "auto",
                width: {
                    xs: "90%",
                    sm: "50%",
                }
            }}
        />
    );
}

const ContentModal = (props: ContentModalProps) => {
    const { ids, idRastreo, onClose } = props;
    const { fetchAllPaquetes, fetchCounts } = usePaqueteStore();
    const { user } = useAuthStore();

    useEffect(() => {
        // Verificar permisos al abrir el modal
        if (user?.role !== UserRole.Admin) {
            toast.error("No tienes permisos para eliminar paquetes");
            onClose();
        }
    }, [user, onClose]);

    const handleDelete = async () => {
        // Verificación adicional de permisos
        if (user?.role !== UserRole.Admin) {
            toast.error("No tienes permisos para eliminar paquetes");
            onClose();
            return;
        }

        try {
            for (const id of ids) {
                await deletePackage(id);
            }
            toast.success('Eliminación exitosa');
            onClose();
        } catch (error) {
            toast.error('Error al eliminar. Intente nuevamente');
        } finally {
            await Promise.all([fetchAllPaquetes(), fetchCounts()]);
        }
    };

    return (
        <Box sx={{ paddingX: "24px", marginBottom: 2, display: "flex", flexDirection: "column", gap: 3 }}>
            <Typography>
                {ids.length > 1 ? `${ids.length} paquetes serán eliminados permanentemente ` : `El paquete ${idRastreo} será eliminado permanentemente `}
                ¿Estás seguro que deseas continuar?
            </Typography>
            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "flex-end", gap: 2 }}>
                <Button onClick={onClose} variant="outlined" size="small">Cancelar</Button>
                <Button onClick={handleDelete} variant="contained" color="error" size="small">
                    Eliminar
                </Button>
            </Box>
        </Box>
    );
};